import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MerchantService {

  constructor( private http: HttpClient){} 

  getData(): Observable<any> {
    return this.http.get(`merchant-details`);
  }
  getConfig(): Observable<any> {
    return this.http.get(`webshop-config`);
  }
}
